import { QueryClient } from "@tanstack/react-query";
import { ZodError } from "zod";

import { isDevelopment } from "./environment";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      throwOnError: (error) => isDevelopment() && error instanceof ZodError,
    },
    mutations: {
      throwOnError: (error) => isDevelopment() && error instanceof ZodError,
    },
  },
});
